import React, { useState } from 'react';

interface JoinRoomFormProps {
  onSubmit?: (pubkey: string, signature: string, toPubkey?: string, toGroupID?: string) => void;
}

const JoinRoomForm: React.FC<JoinRoomFormProps> = ({ onSubmit }) => {
  const [pubkey, setPubkey] = useState('');
  const [signature, setSignature] = useState('');
  const [toPubkey, setToPubkey] = useState('');
  const [toGroupID, setToGroupID] = useState('');
  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(pubkey, signature, toPubkey, toGroupID);
    }
   
  };

  return (
    <form action="#" method="post" className="flex flex-col">
      <label htmlFor="pubkey" className="text-gray-700 mb-2">
        Enter your pubkey:
      </label>
      <input
        type="text"
        id="pubkey"
        name="pubkey"
        placeholder="pubkey of user"
        className="rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring focus:ring-blue-500"
        value={pubkey}
        onChange={(e) => setPubkey(e.target.value)}
      />
      <label htmlFor="toPubkey" className="text-gray-700 mb-2">
        Enter pubkey you want to call:
      </label>
      <input
        type="text"
        id="toPubkey"
        name="pubkey"
        placeholder="If call for group please empty this field"
        className="rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring focus:ring-blue-500"
        value={toPubkey}
        onChange={(e) => setToPubkey(e.target.value)}
      />
      <label htmlFor="groupID" className="text-gray-700 mb-2">
        Enter groupID you want to call:
      </label>
      <input
        type="text"
        id="toGroupID"
        name="pubkey"
        placeholder="Group you want to join"
        className="rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring focus:ring-blue-500"
        value={toGroupID}
        onChange={(e) => setToGroupID(e.target.value)}
      />
      <label htmlFor="signature" className="text-gray-700 mb-2">
        Enter your signature (the signature is the hex text of your key sign on pubkey or group id):
      </label>
      <input
        type="text"
        id="signature"
        name="signature"
        placeholder="Signature"
        className="rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring focus:ring-blue-500"
        value={signature}
        onChange={(e) => setSignature(e.target.value)}
      />
      <button onClick={(e)=>handleSubmit()} type="button" className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4 hover:bg-blue-700">
        Start call
      </button>
    </form>
  );
};

export default JoinRoomForm;
